import { createFileRoute, redirect } from '@tanstack/react-router';

/** Redirects `/o/{org}` to the HLT Cloud home page. */
export const Route = createFileRoute('/_app/o/$organizationId/_platform/')({
    beforeLoad: () => {
        throw redirect({ to: '/', replace: true });
    },
});
